import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface ComdataAvailableLimitTooltipProps {
  className?: string
  openLeft: boolean
}

const ComdataAvailableLimitTooltip: React.FC<
  ComdataAvailableLimitTooltipProps
> = (props): React.ReactElement => {
  return (
    <Tooltip className={props.className} openLeft={props.openLeft}>
      <p>
        <Trns
          source={
            "${comdataAccountInfo} displays the current available limit on your Comdata account. Reaching this limit won't prevent you from issuing virtual cards, but any charges will be declined. To view the most up-to-date limit from Comdata, refresh this page."
          }
          expressions={{
            comdataAccountInfo: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Comdata Account Info'} />
              </span>
            ),
          }}
        />
      </p>
    </Tooltip>
  )
}

export default ComdataAvailableLimitTooltip
